import React from "react";

const Pagination = ({ lastPage, currentPage, onPageChange }) => {
  const totalPages = lastPage;
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPagination = () => {
    const paginationItems = [];

    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`mx-1 rounded-lg px-4 py-2 transition duration-200 ${
            i === currentPage
              ? "bg-blue-500 text-white"
              : "bg-white text-gray-700 hover:bg-blue-600 hover:text-white dark:bg-dark-surface dark:text-white"
          }`}
        >
          {i}
        </button>
      );
    }

    return paginationItems;
  };

  return (
    <div className="mt-10 flex items-center justify-center space-x-2">
      {/* Previous Button */}
      {currentPage > 1 && (
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="rounded-lg bg-white px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white dark:bg-dark-surface dark:text-white"
          aria-label="Previous"
        >
          &#8592;
        </button>
      )}

      {renderPagination()}

      {/* Next Button */}
      {currentPage < totalPages && (
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="rounded-lg bg-white px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white dark:bg-dark-surface dark:text-white"
          aria-label="Next"
        >
          &#8594;
        </button>
      )}
    </div>
  );
};

export default Pagination;
